import React from "react";
import { Button } from "./ui/button";
import { CheckCircle2 } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1559329007-40df8a9345d8')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-32 mt-16">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            FUEL YOUR
            <br />
            RESTAURANT'S GROWTH
            <br />
            WITH INKIND CAPITAL
          </h1>
          
          <div className="space-y-3 mb-8">
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-6 h-6 text-[#D4A574]" />
              <span className="text-white text-lg">6,000+ Restaurants funded</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-6 h-6 text-[#D4A574]" />
              <span className="text-white text-lg">$600M+ inKind Capital deployed</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-6 h-6 text-[#D4A574]" />
              <span className="text-white text-lg">4M+ inKind guests on platform</span>
            </div>
          </div>
          
          <Button 
            onClick={() => document.getElementById('calculator')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-[#D4A574] hover:bg-[#C39564] text-black font-semibold text-lg px-8 py-6"
          >
            GET STARTED
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;